import React, { Component } from "react";
export default class HeaderCollapse extends Component {
 
    constructor() {
        super();
        this.state = {
            isLoading: true
        }
    } 
   async checklogin() {
        if (localStorage.getItem('user-info')) {
      }
    }
    logOut() {
        let user = JSON.parse(localStorage.getItem('user-info'));
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
        event: 'log_out',
        user_id: user.user.id
        });
        localStorage.clear();
    
        window.location.reload();
      }
    componentDidMount() {
        this.checklogin();
    }

    render() {
        const tid = "";

        if (localStorage.getItem('user-info')) {
            let user = JSON.parse(localStorage.getItem('user-info'))

            return (
                <div className="account-menu"> 
                <input type="checkbox" className="user-dropdown" id="user-dropdown" hidden />
                <label className="user-profile" htmlFor="user-dropdown" > 
                    <div className="user">
                        <span className="user-profile-img">
                        <img id="user-profile-img-el" src={ user.user.profile_url ?  user.user.profile_url : "https://srpcawsatdev.prod.acquia-sites.com/themes/custom/aawsatv3/assets-react/img/icon/avatardefault.png"} alt="" />

                            </span>
                            <span className="user-profile-name">{user.user.display_name ? user.user.display_name.substring(0, 15) :"مجهول" }</span>
                    </div>
                    <i className="icomoon-icon icon-arrow-down"></i> 

                </label> 
                <div className="account-menu-list">
                    <ul className="menu vertical">
                    <li><a href="/mybookmarkspage"><i className="icomoon-icon icon-bookmark"></i> محفوظاتي </a></li>
                    <li><a href="/favoritetagspage"><i className="icomoon-icon icon-news"></i> أخباري </a></li>
                    <li><a href="/journey#/mypage"><i className="icomoon-icon icon-news"></i> إدارة أخباري </a></li>
                    <li><a href="/journey#/my_newsletter"><i className="icomoon-icon icon-envelop1"></i>نشراتي البريدية</a></li>
                    <li><a href="/journey#/editprofile"><i className="icomoon-icon icon-user-circle-o"></i> تفاصيل حسابي</a></li>
                    <li><button className="button submit-btn" onClick={this.logOut} ><i className="icomoon-icon icon-sign-out"></i>خروج </button></li>
                    </ul>
                </div>
            </div>)
        } else {
            return (
                <div className="login-btn">
                    <a href="/journey"> <i className="icomoon-icon icon-user-circle-o"></i> <span> تسجيل الدخول </span> </a>
                </div>
            );
        }
    }
}
